<template>
    <div class="page-wrapper document-view-details">
        <div class="container-fluid">
            <div class="page-title">
                <h1>Document View Details</h1>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="document-view-body">
                        <p><img class="elevate-logo" style="width: 10%;" src="@/assets/images/darknuera.png"></p>
                        <div class="directory-block">
                            <h2>{{ data.user_info.first_name }}  {{data.user_info.last_name }}</h2>
                            <ul>
                                <li>{{ data.user_info.address1 }}</li>
                                <li>{{ data.user_info.city }}, {{ data.user_info.state }} {{ data.user_info.zip }}</li>
                            </ul>
                        </div>

                        <p style="text-align:right">November 24th, 2025</p>

                        <p><strong>Dear Valued Member,</strong></p>

                        <p>As of January 1st, 2026, the <strong>{{ this.planName }}</strong> plans will be renewed. There is nothing you need to do on your end as the renewal is automatic. This is just a formal notification of the rate change for 2026.
                      </p>
                        <p>Billing will be adjusted accordingly on your upcoming Statement or Electronic Payment (EFT).</p>
                        <br>
                        <p><strong>Your new rate for your benefit plan as of January 1st, 2026 will be as follows:</strong></p>

                        <div v-if="updatedPlans.length">
                            <div v-for="(plan, index) in updatedPlans" :key="index" class="new-rate-details">
                                <ul >
                                    <li>Plan: <strong>{{ plan.planName }}</strong></li>
                                    <li>Tier: <strong>{{ plan.tierInfo }}</strong></li>
                                    <li>New Rate: <strong>${{ plan.newRate }}</strong></li>
                                </ul>
                            </div>
                        </div>
                        <p class="osf"><em>This new rate will be effective until the next renewal on <strong>December 31st, 2026.</strong></em></p>
                        <p class="osf"><em>If you have any questions, you may contact your representative or broker.</em></p>
                        <br>
                        <!-- <p> <span>Broker: <b>{{ data.agent_name }}</b></span>    <span style="margin-left: 14%;">Phone : <b>{{ data.agent_phone }}</b></span> </p> -->
                        <br>
                        <div class="doc-footer">
                            <p><strong>Sincerely,</strong></p>
                            <p class="osf">NuEra Billing Services</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
/*eslint-disable*/
export default {
    name: 'DocumentViewDetails',
   data: () => ({
        user_id: '',
        data: [],
        plan_name: '',
        updatedPlans: [],
    }),
     methods: {
        async getData(){

            let url = this.$endpoint.VIEW_UPDATE_RATE+this.user_id;
            let loader = this.$loading.show();
            await axios
            .get(url)
            .then((res) => {
                this.data = res.data.data;
                // this.planName = this.data.is_northwell ? this.data.old_plan_name : this.data.plan_name
                // this.planName += this.data.met_life_details?.plan_name ? ', '+ this.data.met_life_details?.plan_name : ''

                if (Array.isArray(this.data.updated_plans)) {
                    this.updatedPlans = this.data.updated_plans.map((plan) => ({
                        planName: plan.plan_name,
                        tier: plan.tier,
                        tierInfo: plan.tier_info,
                        newRate: plan.new_rate,
                    }));
                    // Populate planName with all plan names from updatedPlans, separated by commas
                    this.planName = this.updatedPlans.map((plan) => plan.planName).join(", ");
                }
            })
            .finally(() => {
                loader.hide();
            });
        },
    },
    created() {
        this.user_id = parseInt(atob(this.$route.params.userId));
        this.getData();
    },
}
</script>
<style src="../assets/css/directory.css" scoped></style>
<style>
.document-view-body {
    background: #fff;
    box-shadow: 0 2px 15px rgb(216 227 235 / 33%);
    padding: 30px;
    padding-top: 20px;
    margin-top: 20px;
    border-radius: 15px;
}
.document-view-body p {
    font-size: 14px;
    margin-bottom: 10px;
}
.new-rate-details {
    padding: 30px;
    max-width: 800px;
    margin-bottom: 13px;
    background: #f3f7fa;
    border-radius: 10px;
    margin-top: 15px;
}
.document-view-body .osf {
    opacity: 0.7;
    margin-bottom: 5px;
}
.new-rate-details ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
}
.new-rate-details ul li {
    display: inline-block;
}
.new-rate-details strong {
    color: #03c3ec;
}
.doc-footer p {
    margin-bottom: 4px;
}
.doc-footer .osf {
    margin-bottom: 2px;
}
.elevate-logo {
    /* width: 20%; */
    display: block;
    margin: 0px auto;
    margin-top:2%
}
</style>
